import { Grid } from '@mui/material';
import { FormTitle } from '@styles/ContactManager/DealStyles';
import { ProductStatus } from '../constants';
import { DealProduct, ProductPlan } from '../interfaces';


interface IEditRetailFormRules {
  productRules: ProductPlan[];
  dealProducts?: DealProduct[];
}

export const EditRetailFormRules= ({ productRules, dealProducts = [] } : IEditRetailFormRules) => (
  <>
    <Grid container item spacing={3} sx={{ mt: '20px' }}>
      <Grid item xs={2}>
        <FormTitle> Rules:</FormTitle>
      </Grid>
    </Grid>
    {productRules.map(
      (product: ProductPlan, index) =>
        !!product.productTypeRuleDescription && (
          <Grid key={index} container item spacing={3}>
            <Grid item xs={1}>
              <FormTitle>{product.productName}</FormTitle>
            </Grid>
            <Grid item xs={6}>
              {product.productTypeRuleDescription}
            </Grid>
          </Grid>
        ),
    )}
    <Grid container item spacing={3}>
      <Grid item xs={2}>
        <FormTitle>Contract Results:</FormTitle>
      </Grid>
    </Grid>
    {dealProducts.map(
      (product: DealProduct, index) =>
        product.status !== ProductStatus.NOT_CONTRACTED && (
          <Grid key={index} container item spacing={3}>
            <Grid item xs={1}>
              <FormTitle>{product.productTypeName}</FormTitle>
            </Grid>
            <Grid item xs={6}>
              {product.status}
            </Grid>
          </Grid>
        ),
    )}
  </>
);
